<template>
  <div class="simulation">
    <div class="simulation-header">
      <h1> {{ data.Header }}</h1>
    </div>
    <div class="" :style="`
      display: flex;
      flex-direction: ${$vuetify.breakpoint.smAndDown ? 'column;' : 'row;'}
      gap: 20px;
    `">
      <div class="simulation-content-image">
        <img v-if="name === 'Overview'" style="border-radius: 10px" width="100%" src="@/assets/training.jpg" />
        <img v-else-if="name === 'FoundationBlock'" style="border-radius: 10px" width="100%" src="@/assets/Simulation-FoundationBlock.jpeg" />
        <img v-else-if="name === 'FoundationStrip'" style="border-radius: 10px" width="100%" src="@/assets/Simulation-FoundationStrip.jpeg" />
        <img v-else-if="name === 'Column'" style="border-radius: 10px" width="100%" src="@/assets/Simulation-Column.jpeg" />
        <img v-else-if="name === 'ConnectorTop'" style="border-radius: 10px" width="100%" src="@/assets/Simulation-ConnectorTop.jpeg" />
        <img v-else-if="name === 'OutsideWall'" style="border-radius: 10px" width="100%" src="@/assets/Simulation-OutsideWall.jpeg" />
        <img v-else-if="name === 'Roof'" style="border-radius: 10px" width="100%" src="@/assets/Simulation-Roof.jpeg" />
        <img v-else-if="name === 'RoofConnector'" style="border-radius: 10px" width="100%" src="@/assets/Simulation-RoofConnector.jpeg" />
        <img v-else-if="name === 'Beam'" style="border-radius: 10px" width="100%" src="@/assets/Simulation-Beam.jpeg" />
        <img v-else-if="name === 'Gutters'" :style="`border-radius: 10px;`" width="100%" src="@/assets/Simulation-Gutters.jpeg" />
        <img v-else-if="name === 'FoundationTop'" :style="`border-radius: 10px;`" width="100%" src="@/assets/Simulation-FoundationTop.jpeg" />

      </div>
      <div class="simulation-content-boxes">
        <div v-if="data.Info != undefined" class="simulation-content-one">
          <h2 style="text-align: center; padding: 8px"> {{ data.InfoHeader }} </h2>
          <div v-for="list_entry in data.Info" :key="list_entry.index" class="simulation-content-text" style="padding: 0px; display: flex; flex-direction: row; justify-content: center; width: 100%; gap: 10px;">
            <div style="width: 100%; display: flex; justify-content: flex-end">
              <p> {{ list_entry.left }} </p>
            </div>
            <p> - </p>
            <div style="width: 100%">
              <p> {{ list_entry.right }} </p>
            </div>
          </div>
        </div>
        <div v-if="data.Description != undefined || data.Rules != undefined" class="simulation-content-two">
          <div v-if="data.Description != undefined" class="simulation-content-text">
            <h2 v-if="data.DescriptionHeader != undefined"> {{data.DescriptionHeader}} </h2>
            <ul v-html="'<li>' + data.Description.join('</li><li>') + '</li>'" style="margin: 3px"/>
          </div>
          <hr v-if="data.Rules != undefined" style="background: white; border: none; height: 1px; width: 94%; margin-left: 3%; margin-right: 3%; margin-bottom: 3px">
          <div v-if="data.Rules != undefined" class="simulation-content-text">
            <h2 v-if="data.RulesHeader != undefined"> {{data.RulesHeader}} </h2>
            <ul v-html="'<li>' + data.Rules.join('</li><li>') + '</li>'" style="margin: 3px"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['name', 'data'],
    data: () => ({
    }),
  }
</script>
<style>
.simulation {
  height: calc(100% - 78px) !important;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
}
.simulation-header {
  width: 100%;
  text-align: center;
  /* background-color: #292929; */
  border: solid 1px white;
  padding: 10px;
  border-radius: 10px;
}
.simulation-content {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
.simulation-content-image {
  width: 100%;
}
.simulation-content-boxes {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.simulation-content-one {
  background-color: #292929;
  border-radius: 10px;
}
.simulation-content-two {
  background-color: #292929;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}
.simulation-content-text {
  padding: 10px;
  font-size: 20px;
  font-weight: 400;
}

</style>
